import moment from 'moment/moment';

export enum BPFDealStatus {
  Healthy = 'HEALTHY',
  Hot = 'HOT',
  Stalled = 'STALLED',
  AtRisk = 'AT_RISK',
}

export interface ReportsListingViewModel {
  id: string;
  stage: string;
  customer: string;
  invoiceAmount: string;
  createdDateTime: string;
  estimatedCloseDate: string | null;

  grossProfit: number;
  overdueInDays: number;
  location: string | null;
  closeDate: string | null;
  department: string | null;
  closeStatus: string | null;
  daysInStage: string | null;
  probability: string | null;
  weightedAmount: string | null;
  dealStatus: BPFDealStatus;
}

export interface ReportsListingGroupViewModel {
  name: string;

  meta: {
    label: string;
    invoiceSubTotal: string;
  };

  data: ReportsListingViewModel[];
}

export interface ReportsListingFilters {
  search: string;
  stageName: string;
  locationId: string;
  departmentId: string;
  salesPersonId: string;
  to: moment.Moment;
  from: moment.Moment;
}

export interface ReportSummaryGroup {
  key: string;
  name: string;
  voCount: number;
  invoiceSum: number;
}

export interface ReportSummaryPagination {
  page: number;
  total: number;
  perPage: number;
  totalPages: number;
}

export interface ReportSummary {
  stageId: string;
  dealsSum: number;
  stageName: string;
  department: string;
  dealsAmount: number;
}

export interface GroupsSummaryData {
  data: Array<ReportSummary>;
  dealsSum: number;
  dealsAmount: number;
}

export interface GroupsSummaryResponse {
  summary: GroupsSummaryData;
  groups: Array<ReportSummaryGroup>;
  pagination: ReportSummaryPagination;
}

export interface GroupsItemsResponse {
  groupKey: string;
  pagination: ReportSummaryPagination;
  data: Array<ReportsListingViewModel>;
}

export interface FullReportResponse {
  summary: GroupsSummaryData;
  list: {
    name: string;
    data: ReportsListingViewModel[];
    meta: {
      label: string;
      invoiceSubTotal: string;
    };
  }[];
}
